import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import GatewayRedisAndLogisticsInfoComponent from './gateway-redis-logistics-info.component';

export default function GatewaySettingsInfoComponent({ stores, domains, handleFormChange, selectedGateway }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled
              label="Gateway"
              name="Gateway"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Gateway',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Gateway}
            />
            <InputContainer
              isDisabled
              label="Registry"
              name="Registry"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Registry',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Registry}
            />
            <InputContainer
              isDisabled
              label="BAP Id"
              name="BapId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BapId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BapId}
            />
            <InputContainer
              isDisabled
              label="bap Url"
              name="BapUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BapUri',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BapUri}
            />
            <InputContainer
              isDisabled
              label="bpp Id"
              name="BppId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BppId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BppId}
            />
            <InputContainer
              isDisabled
              label="bpp Url"
              name="BppUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BppUri',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BppUri}
            />
            <InputContainer
              isDisabled
              label="Domain"
              name="Domain"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Domain',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Domain}
            />
            <InputContainer
              isDisabled
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Port',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Port}
            />
            <InputContainer
              isDisabled
              label="Core Version"
              name="CoreVersion"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.CoreVersion',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.CoreVersion}
            />
            <InputContainer
              isDisabled
              label="Tenant"
              name="Tenant"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Tenant',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Tenant}
            />
            <InputContainer
              isDisabled
              label="Requester"
              name="Requester"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Requester',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Requester}
            />
            <InputContainer
              isDisabled
              label="Store"
              labelField="StoreName"
              list={stores}
              onValueChange={(event: any, newValue: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.StoreId',
                  selectedGateway?.Settings
                )
              }}
              optionName='Choose Store'
              type="select"
              value={selectedGateway?.Settings?.StoreId}
              valueField="Id"
            />
            <InputContainer
              isDisabled
              label="Channel Name"
              name="ChannelName"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.ChannelName',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.ChannelName}
            />
            <InputContainer
              isDisabled
              label="Internal Account Id"
              name="InternalAccountId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.InternalAccountId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.InternalAccountId}
            />
            <InputContainer
              isDisabled
              label="Email Domain"
              name="EmailDomain"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.EmailDomain',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.EmailDomain}
            />
            <InputContainer
              isDisabled
              label="Default User Email"
              name="DefaultUserEmail"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.DefaultUserEmail',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.DefaultUserEmail}
            />
            <InputContainer
              isDisabled
              label="Default User Phone"
              name="DefaultUserPhone"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.DefaultUserPhone',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.DefaultUserPhone}
            />
            <InputContainer
              isDisabled

              label="Secret Key"
              name="SecretKey"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.SecretKey',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.SecretKey}
            />
            <InputContainer
              isDisabled

              label="Ondc Token"
              name="OndcToken"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.OndcToken',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.OndcToken}
            />
          </div>
        }
        expandedPanel="Settings Info"
        headerTitle="Settings Info"
      />

      <GatewayRedisAndLogisticsInfoComponent
        handleFormChange={handleFormChange}
        selectedGateway={selectedGateway}
        domainsList={domains}
      />
    </>
  )
}